export class SearchDisplayModel {
  displayText: string;
  searchType: string;
  imageName: string;
  className: string;
  searchCriteria: { imageName: string; displayText: string }[];
}
